import { createFileRoute } from '@tanstack/react-router';

import { AccountPage } from '~/modules/account';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.pageTitle, { ns: 'account' });

export const Route = createFileRoute('/(main)/account/')({
  component: AccountPage,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const ACCOUNT = buildRouteExport({ Route });
